/**
 * Dinamik modül / chunk yükleme kurtarma mimarisi.
 * Yeni bir sürüm deploy edildiğinde eski hash'li chunk'ları isteyen açık sekmelerde
 * ortaya çıkan tarayıcı hatalarını yakalar, döngüye girmeden sayfayı yenileyerek
 * kullanıcının en güncel sürüme kesintisiz geçmesini sağlar.
 */

const RELOAD_KEY = "halkora:last_chunk_reload";
const RELOAD_DEBOUNCE_MS = 20_000;

/**
 * Verilen hatanın bir dinamik chunk / script import hatası olup olmadığını tespit eder.
 * Safari: "Importing a module script failed."
 * Chrome/Edge: "Failed to fetch dynamically imported module: ..."
 * Firefox/Webpack: "error loading dynamically imported module" / "Loading chunk"
 */
export function isChunkLoadError(err: unknown): boolean {
  if (!err) return false;
  let msg = "";
  if (typeof err === "string") {
    msg = err;
  } else if (err instanceof Error) {
    msg = `${err.name} ${err.message} ${err.stack ?? ""}`;
  } else if (typeof err === "object" && "message" in err) {
    msg = String((err as { message?: unknown }).message ?? "");
  } else {
    msg = String(err);
  }

  // hk-izin: tarayici dinamik import hata mesaji kontrolu
  const lower = msg.toLowerCase();
  return (
    lower.includes("importing a module script failed") ||
    lower.includes("failed to fetch dynamically imported module") ||
    lower.includes("error loading dynamically imported module") ||
    lower.includes("loading chunk") ||
    lower.includes("failed to load module script") ||
    lower.includes("unable to preload css") ||
    lower.includes("vite:preloaderror")
  );
}

/**
 * Chunk hatası oluştuğunda döngüye girmeden (en fazla 20 saniyede 1 kez) sayfayı yeniler.
 * Yenileme başlatıldıysa true döner.
 */
export function handleChunkError(err: unknown): boolean {
  if (!isChunkLoadError(err)) return false;

  if (typeof window === "undefined") return false;

  try {
    const now = Date.now();
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (!last || now - last > RELOAD_DEBOUNCE_MS) {
      sessionStorage.setItem(RELOAD_KEY, String(now));
      window.location.reload();
      return true;
    }
  } catch {
    // sessionStorage erişilemezse (özel mod kısıtı vb.) doğrudan bir kez yenile
    window.location.reload();
    return true;
  }

  return false;
}
